// <-- Core Imports -->
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "../assets/translate/en.json";
import es from "../assets/translate/es.json";

// Normalize language to supported languages (en, es)
const normalizeLanguage = (lng: string | null): string => {
  if (!lng) return "en";
  const baseLang = lng.split("-")[0].toLowerCase();
  return baseLang === "es" ? "es" : "en"; // Default to English for any non-Spanish language
};

// Get initial language from localStorage or default to English
const storedLanguage = localStorage.getItem("language");
const initialLanguage = normalizeLanguage(storedLanguage);

// Ensure localStorage has the normalized value
if (!storedLanguage || storedLanguage !== initialLanguage) {
  localStorage.setItem("language", initialLanguage);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: initialLanguage, // Set initial language explicitly
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    resources: {
      en: {
        translation: en,
      },
      es: {
        translation: es,
      },
    },
    detection: {
      // Order of detection - localStorage takes priority
      order: ["localStorage"],
      // Cache user language selection in localStorage
      caches: ["localStorage"],
      // Key to use in localStorage
      lookupLocalStorage: "language",
    },
    supportedLngs: ["en", "es"],
    load: "languageOnly", // Only load 'en' not 'en-US' or 'en-GB'
  });

export default i18n;
